export const LIVESTOCK_MAJOR_MEASURE_TYPES_FILTER = [
  {
    text: 'Live Weight Measurements',
    value: 'Live Weight Measurements'
  },
  {
    text: 'Carcass Traits',
    value: 'Carcass Traits'
  },
  {
    text: 'Ultrasound Measurements',
    value: 'Ultrasound Measurements'
  },
  {
    text: 'Linear Body Measurements',
    value: 'Linear Body Measurements'
  },
  {
    text: 'Growth Performance',
    value: 'Growth Performance'
  },
  {
    text: 'Reproductive Traits',
    value: 'Reproductive Traits'
  },
  {
    text: 'Functional Traits',
    value: 'Functional Traits'
  },
  {
    text: 'Economic & Management',
    value: 'Economic & Management'
  }
];

export const LIVESTOCK_MINOR_MEASURE_TYPES_FILTER = [
  {
    text: 'Birth Weight',
    value: 'Birth Weight'
  },
  {
    text: 'Weaning Weight',
    value: 'Weaning Weight'
  },
  {
    text: 'Yearling Weight',
    value: 'Yearling Weight'
  },
  {
    text: '18-Month Weight',
    value: '18-Month Weight'
  },
  {
    text: 'Mature Weight',
    value: 'Mature Weight'
  },
  {
    text: 'Post-Calving Cow Weight',
    value: 'Post-Calving Cow Weight'
  },
  {
    text: 'Post-Weaning Cow Weight',
    value: 'Post-Weaning Cow Weight'
  },
  {
    text: 'Purchase Weight',
    value: 'Purchase Weight'
  },
  {
    text: 'Sale Weight',
    value: 'Sale Weight'
  },
  {
    text: 'Slaughter Weight',
    value: 'Slaughter Weight'
  },
  {
    text: 'Regulatory Weight',
    value: 'Regulatory Weight'
  },
  {
    text: 'Management Weight',
    value: 'Management Weight'
  },
  {
    text: 'Carcass Weight',
    value: 'Carcass Weight'
  },
  {
    text: 'Conformation Score',
    value: 'Conformation Score'
  },
  {
    text: 'Fat Content',
    value: 'Fat Content'
  },
  {
    text: 'Retail Beef Yield',
    value: 'Retail Beef Yield'
  },
  {
    text: 'Backfat Thickness',
    value: 'Backfat Thickness'
  },
  {
    text: 'Ribeye Area',
    value: 'Ribeye Area'
  },
  {
    text: 'Marbling Score',
    value: 'Marbling Score'
  },
  {
    text: 'Withers Height',
    value: 'Withers Height'
  },
  {
    text: 'Hip Height',
    value: 'Hip Height'
  },
  {
    text: 'Body Length',
    value: 'Body Length'
  },
  {
    text: 'Chest Girth',
    value: 'Chest Girth'
  },
  {
    text: 'Pelvic Score',
    value: 'Pelvic Score'
  },
  {
    text: '200-Day Growth',
    value: '200-Day Growth'
  },
  {
    text: '400-Day Growth',
    value: '400-Day Growth'
  },
  {
    text: '600-Day Growth',
    value: '600-Day Growth'
  },
  {
    text: 'Growth During Test Period',
    value: 'Growth During Test Period'
  },
  {
    text: 'Growth During Summer',
    value: 'Growth During Summer'
  },
  {
    text: 'Veld Conversion Rate',
    value: 'Veld Conversion Rate'
  },
  {
    text: 'Calving Ease (Direct)',
    value: 'Calving Ease (Direct)'
  },
  {
    text: 'Calving Intervals',
    value: 'Calving Intervals'
  },
  {
    text: 'Milk (Maternal)',
    value: 'Milk (Maternal)'
  },
  {
    text: 'Scrotal Circumference',
    value: 'Scrotal Circumference'
  },
  {
    text: 'Docility',
    value: 'Docility'
  },
  {
    text: 'Temperament Score',
    value: 'Temperament Score'
  },
  {
    text: 'Muscling Score',
    value: 'Muscling Score'
  },
  {
    text: 'Hair Score',
    value: 'Hair Score'
  },
  {
    text: 'Weaner Score',
    value: 'Weaner Score'
  },
  {
    text: 'Economic Index',
    value: 'Economic Index'
  },
  {
    text: 'Feedlot Index',
    value: 'Feedlot Index'
  },
  {
    text: 'Purchase Price (Live)',
    value: 'Purchase Price (Live)'
  },
  {
    text: 'Sale Price (Live)',
    value: 'Sale Price (Live)'
  },
  {
    text: 'Sale',
    value: 'Sale'
  },
  {
    text: 'Management Value',
    value: 'Management Value'
  },
  {
    text: 'Tax Value',
    value: 'Tax Value'
  },
  {
    text: 'Management Teeth Age',
    value: 'Management Teeth Age'
  }
];

export const MAJOR_MEASURE_TYPES = LIVESTOCK_MAJOR_MEASURE_TYPES_FILTER.map(t => t.text);
export const MINOR_MEASURE_TYPES = LIVESTOCK_MINOR_MEASURE_TYPES_FILTER.map(t => t.text);

export const ANIMAL_ERRORS = {
  ASSIGNED_TO_DIFFERENT_GEOFENCE:
    'One or more livestock is in a group that is assigned to a different pasture. Do you want to assign this livestock to a different pasture? If you select Yes, this livestock will be removed from the group and assigned to the new pasture.',
  NOT_ASSIGNED_TO_GEOFENCE:
    'One or more livestock is in a group that is not assigned to a pasture. Do you want to assign this livestock to a new and different pasture? If you select Yes, this livestock will be removed from this group and assigned to the new pasture.',
  UPDATE_GEOFENCE_TO_GROUP:
    'One or more of the selected livestock is already assigned to a different pasture. Do you want to update the pasture for this livestock to be the same as the pasture for the group?',
  REASSIGN_LIVESTOCK: (groupName) =>
    `This livestock is already assigned to ${groupName}. Do you want to remove this livestock from ${groupName} and assign it to this group?`
};

export const BLANK_FILTER_TEXT = 'Blank';

export const TREATMENT_TYPES = [
  'Vaccination',
  'Antiparasitic',
  'Antimicrobial',
  'Reproductive',
  'Surgical',
  'Hoof',
  'Injury',
  'Nutritional',
  'Poison',
  'Other'
];
